// tslint:disable-next-line:no-var-requires
const YubinBangoCore = require('yubinbango-core2');
export default function SearchPostalCode(postalCode, callback = (value) => { }) {
    if (!postalCode.match(/^\d{3}-?\d{4}$/)) {
        callback(null);
    }
    new YubinBangoCore.Core(postalCode, (value) => {
        callback(value);
        // region,
        // region_id,
        // locality,
        // street,
        // extended,
    });
}
